import React from "react"
import classNames from "classnames"
import { Hint } from "./Hint"
import { FormElement } from "./form"
import { withFieldLabelAndHint } from "./field"

type Props = {
  label: string | JSX.Element
  type?: "checkbox" | "radio"
  hint?: string
} & FormElement &
  React.InputHTMLAttributes<HTMLInputElement>

const Checkmark = ({ label, status, hint, ...inputProps }: Props) => {
  return (
    <div
      className={classNames("cobalt-CheckmarkField", {
        "cobalt-CheckmarkField--success": status === "success",
        "cobalt-CheckmarkField--error": status === "error",
      })}
    >
      <label className="cobalt-CheckmarkField__LabelWrapper">
        <input {...inputProps} className="cobalt-CheckmarkField__Input" />
        <span className="cobalt-CheckmarkField__Checkmark" />
        <span className="cobalt-CheckmarkField__Label">{label}</span>
      </label>
      {hint && (
        <Hint status={status}>
          <span dangerouslySetInnerHTML={{ __html: hint }} />
        </Hint>
      )}
    </div>
  )
}

export const Checkbox = ({ label, ...props }: Props) => {
  return <Checkmark {...props} label={label} type="checkbox" />
}
Checkbox.displayName = "CobaltCheckbox"

export const Radio = ({ label, ...props }: Props) => {
  return <Checkmark {...props} label={label} type="radio" />
}
Radio.displayName = "CobaltRadio"

type ChoiceListProps = {
  children: React.ReactNode | (() => React.ReactNode)
}

const ChoiceList = ({ children }: ChoiceListProps) => {
  return (
    <div className="cobalt-ChoiceList">
      {typeof children === "function" ? children() : children}
    </div>
  )
}

const wrappedChoiceList = withFieldLabelAndHint(ChoiceList)
wrappedChoiceList.displayName = "ChoiceList"

export { wrappedChoiceList as ChoiceList }
